import { MeetingsSidePanel } from "components/Meetings/components/MeetingsSidePanel";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectRightPanelState } from "reducers/rightPanel";
import { RightPanelGeneric } from "./RightPanelGeneric";

const RightPanelRouter = () => {
  const rightPanelType = useSelector(selectRightPanelState);
  const [panel, setPanel] = useState<any>(null);
  const [panelOpen, setPanelOpen] = useState<any>(null);
  React.useEffect(() => {
    switch (rightPanelType.panelType) {
      case "MEETING_DETAILS":
        setPanel(<MeetingsSidePanel data={rightPanelType.data} />);
        break;
      default:
        setPanel(null);
        break;
    }
  }, [rightPanelType.panelType, rightPanelType.data]);

  return (
    <>
      {panel ? (
        <RightPanelGeneric
          title={rightPanelType.data && rightPanelType.data.title}
          rightPanelContent={true}
        >
          {panel}
        </RightPanelGeneric>
      ) : (
        <RightPanelGeneric rightPanelContent={false} />
      )}
    </>
  );
};

export { RightPanelRouter };
